var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMonthlysubscription(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 119.455,
    height: 95.638,
    viewBox: "0 0 119.455 95.638",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.614,
    y1: 0.207,
    x2: 0.588,
    y2: 0.973,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#18ceae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03a7ea"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "monthly-subscription",
    transform: "translate(-792.667 -1030.362)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1884",
    "data-name": "Path 1884",
    d: "M3302.667,1020l118.667,92v-49.333L3364,1020Z",
    transform: "translate(-2510 14)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("text", {
    id: "_Subscription",
    "data-name": " Subscription",
    transform: "matrix(0.788, 0.616, -0.616, 0.788, 859.794, 1078.811)",
    fill: "#fff",
    fontSize: 12,
    fontFamily: "OpenSans-Bold, Open Sans",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -45.387,
    y: 0,
    xmlSpace: "preserve"
  }, " SUBSCRIPTION")), /*#__PURE__*/React.createElement("text", {
    id: "Monthly_",
    "data-name": "Monthly ",
    transform: "matrix(0.788, 0.616, -0.616, 0.788, 869.347, 1069)",
    fill: "#fff",
    fontSize: 16,
    fontFamily: "OpenSans-Bold, Open Sans",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -40.68,
    y: 0
  }, "MONTHLY"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 22
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonthlysubscription);
export default __webpack_public_path__ + "static/media/monthlysubscription.ac6949cd83673134ca6da90694783b8b.svg";
export { ForwardRef as ReactComponent };